import styled from 'styled-components';
import { H3 } from 'components/Typography';

import theme from 'styles/theme';

export const Work = styled.div`
  display: flex;
  flex-flow: column;
  background: ${theme.B400};
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);

  .Work__content {
    flex: 1 1 auto;
    padding: 20px;
  }

  .Work__tags {
    display: flex;
    color: ${theme.font_secondary};
    flex-flow: row wrap;
    list-style-type: none;
    padding: 0;
    margin: 0 0 0.75rem;

    &-tag {
      font-weight: 500;
      font-size: 1rem;
      font-style: italic;

      &:after {
        display: inline-flex;
        content: '//';
        padding: 0 5px;
      }

      &:last-child {
        margin: 0;

        &:after {
          content: none;
        }
      }
    }
  }

  .Work__description {
    display: flex;
    flex-direction: column;
  }

  .Work__action {
    flex: 0 0 auto;
    background: ${theme.B500};
    color: ${theme.font_primary};
    text-transform: uppercase;
    text-align: center;
    padding: 10px 25px;
    transition: background 500ms;

    &:hover {
      background: ${theme.B400};
    }
  }
`;

export const WorkTitle = H3.extend`
  font-weight: 500;
  margin: 0 0 5px;
`;

export default Work;



// WEBPACK FOOTER //
// ./src/components/Work/Work.styles.js